import logService from "./log.service";

const axios = require('axios').default;
const RESOURCE_NAME = process.env.REACT_APP_API_BASE + '/lessons';

const getHeader = (token) => {
    if (!token) {
        token = localStorage.getItem("accessToken");
    }
    return {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
};

export default {
    lessonInfo(lessonCode, token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        logService.log("info", "lessonInfo", `${RESOURCE_NAME}/info/${lessonCode}/`, JSON.stringify(requestOptions));
        return axios.get(`${RESOURCE_NAME}/info/${lessonCode}/`, requestOptions);
    },

    startLesson(lessonCode, token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        logService.log("info", "startLesson", `${RESOURCE_NAME}/start/${lessonCode}/`, JSON.stringify(requestOptions));
        return axios.post(`${RESOURCE_NAME}/start/${lessonCode}/`, {}, requestOptions);
    },

    submitLesson(lessonCode, answers) {
        const requestOptions = {
            headers: getHeader(),
        };
        const logData = {
            headers: getHeader(),
            answers: answers
        };
        logService.log("info", "submitLesson", `${RESOURCE_NAME}/submit/${lessonCode}/`, JSON.stringify(logData));
        // logService.log("info", "submitLesson", `${RESOURCE_NAME}/submit/${lessonCode}/`, JSON.stringify(requestOptions));
        // logService.log("info", "submitLesson", `${RESOURCE_NAME}/submit/${lessonCode}/`, JSON.stringify({answers: answers}));
        return axios.post(`${RESOURCE_NAME}/submit/${lessonCode}/`, JSON.stringify({answers: answers}), requestOptions);
    },

    getLessonResult(testId, token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        // logService.log("info", "getLessonResult", `${RESOURCE_NAME}/result/${testId}/`, JSON.stringify(requestOptions));
        return axios.get(`${RESOURCE_NAME}/result/${testId}/`, requestOptions);
    },

    getLessonResultDetail(testId, tryTime, token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        // logService.log("info", "getLessonResultDetail", `${RESOURCE_NAME}/result/${testId}/detail/${tryTime}/`, JSON.stringify(requestOptions));
        return axios.get(`${RESOURCE_NAME}/result/${testId}/detail/${tryTime}/`, requestOptions);
    },
}
